<div class="row">
     <div class="col-12" >
          <div class="row justify-content-between align-items-center" id="page-title">
               <h1 class="progress-header col-12 col-lg-auto" [innerHTML]="'Enroll in PSP_MAIN' | translator:'base'">
                    Enroll in PSP</h1>
          </div>
          <div class="row mb-2">
               <span class="col-12 col-lg-auto d-flex align-items-center small">
                    <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
                    <span [innerHTML]="'Start_8-1' | translator:'base'">
                         Are you a <strong>driver</strong> looking for your own PSP record?
                    </span>
                    <a routerLink="/driver/1" (click)="scrollToTop()" name="Driver-record-request"
                         id="Driver-record-request" [title]="'Start_8-2' | translator:'base'" class="ms-1">
                         <span [innerHTML]="'Start_8-2' | translator:'base'">Access your PSP record
                              here.</span>
                    </a>
               </span>
          </div>
          <div class="row">
               <div class="col-lg-8">
                    <div class="card shadow-sm rounded-0 border-0">
                         <div class="card-body">
                              <app-complete-bar [step]="13" [totalSteps]="19"></app-complete-bar>
                              <h2 [innerHTML]="'ReviewHow_1' | translator:'base'">Review</h2>
                              <p class="step-text" ><span [innerHTML]="'ReviewHow_2' | translator:'base'">How did you learn
                                   about PSP?</span> <span class="text-danger text-center ms-1"
                                    [title]="'Required' | translator:'base'">*</span></p>
                              <hr>
                              <div class="mt-12"></div>

                              <app-marketing-source *ngIf="isLoading === false" [marketingSources]="marketingSources" [selectedItem]="null"
                                   [labelColCss]="'d-none'" [inputColCss]="'col-12'"
                                   [(value)]="_discoveredViaEdit"></app-marketing-source>
                              <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                                   <div class="btn-group" role="group">
                                        <button routerLink="/signup/18" (click)="scrollToTop()"
                                             [disabled]="pageInvalid()" class="btn btn-primary btn-strong"
                                             [title]="'ReviewHow_9' | translator:'base'"
                                             name="companyNext18" id="companyNext18">
                                             <span [innerHTML]="'Continue' | translator:'base'">Continue</span>
                                             <span class="sr-only">&nbsp;</span>
                                             <span class="sr-only" [innerHTML]="'ReviewHow_9' | translator:'base'">Terms
                                                  & Conditions</span>
                                        </button>
                                   </div>
                                   <div class="btn-group" role="group">
                                        <button routerLink="/signup/16" class="btn btn-outline-primary"
                                             (click)="scrollToTop()" [title]="'Review' | translator:'base'" 
                                             name="companyBack18" id="companyBack18">
                                             <span [innerHTML]="'Back' | translator:'base'">Back</span>
                                             <span class="sr-only">&nbsp;</span>
                                             <span class="sr-only"
                                                  [innerHTML]="'ReviewHow_10' | translator:'base'">Review Users</span>
                                        </button>
                                        <button routerLink="/" class="btn btn-light" (click)="scrollToTop()"
                                             name="companyCancel18" id="companyCancel18"
                                             [innerHTML]="'Cancel' | translator:'base'"
                                             [title]="'Cancel' | translator:'base'"></button>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
               <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="4"
                    [pageType]="enrollmentService.newCustomer!.customerType || '-'"
                    class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
          </div>
     </div>
</div>